export const Loading = () => {
  return (
    <div className="flex justify-center m-4" aria-label="読み込み中">
      <div className="animate-spin h-6 w-6 border-2 border-blue-500 rounded-full border-t-transparent"></div>
    </div>
  );
};
